// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import annotationAlertIcon from "@/assets/icons/annotation-alert.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type AnnotationAlertIconProps = Omit<IconProps, "name">;

export function AnnotationAlertIcon(props: AnnotationAlertIconProps): React.ReactNode {
  return <Icon name={annotationAlertIcon} {...props} />;
}
